angular
  .module('contributor')

  .directive('contributorsFilter', [
    function() {
      return {
        restrict: 'E',
        require: '^ngModel',
        replace: true,
        scope: {
          filtersModel: '=ngModel',
          performSearch: '&search',
          reset: '&'
        },
        templateUrl:
          'custom/contributor/views/partials/contributorsFilter.html',
        controller: [
          '$scope',
          '$controller',
          'LoggedUser',
          'RatingVoiceCrud',
          function($scope, $controller, LoggedUser, RatingVoiceCrud) {
            $scope.prefix = 'contributor';

            $controller('filterController', {
              $scope: $scope
            });

            $scope.lang = LoggedUser.getData().lang || 'it';

            const filterRatingCodes = [6, 7, 8, 9, 10, 11];

            new RatingVoiceCrud().query().then(response => {
              $scope.generalRatings = (response || [])
                .filter(i => i && i.general)
                .map(i => ({
                  code: +i.code || i.code,
                  value:
                    (
                      (i.name || []).find(n => n.lang === $scope.lang) ||
                      (i.name || [])[0]
                    ).value || ''
                }))
                .filter(i => i.value && filterRatingCodes.includes(i.code))
                .sort((a, b) => a.code - b.code);
            });
          }
        ]
      };
    }
  ]);
